import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-slate-900 text-slate-400 py-12 px-6 border-t border-slate-800">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
                {/* Logo / Brand */}
                <div className="flex flex-col items-center md:items-start gap-2">
                    <span className="text-xl font-black text-white tracking-tighter">
                        Trouve<span className="text-blue-500">tonVIE</span>
                    </span>
                    <p className="text-xs max-w-xs text-center md:text-left">
                        La plateforme de référence pour trouver votre V.I.E. à l'international.
                    </p>
                </div>

                {/* Links */}
                <div className="flex flex-wrap justify-center gap-8 text-sm font-medium">
                    <Link to="/mentions-legales" className="hover:text-white transition-colors">Mentions Légales</Link>
                    <Link to="/cgu" className="hover:text-white transition-colors">CGU</Link>
                    <Link to="/confidentialite" className="hover:text-white transition-colors">Politique de Confidentialité</Link>
                    <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
                </div>

                {/* Copyright */}
                <div className="text-xs text-slate-600 font-bold">
                    © 2026 TrouvetonVIE. Tous droits réservés.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
